import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Colton Wiscombe
 * id 7761450F-6D9D-452D-B604-1853124C09E2
 * name minus-thick
 * version: 5.7.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/minus-thick.svg
 * tags
 */
export const MinusThickIcon = createSvgIcon(<><path d="M20 14H4V10H20" /></>, 'MinusThickIcon');
export default MinusThickIcon